import React, { Component } from "react";
import {
  Typography,
  Box,
  IconButton,
  Button,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  Collapse,
  Alert,
  CardActionArea,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import ShareIcon from "@mui/icons-material/Share";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Serverurl from "./Apiurl";
import EmailIcon from "@mui/icons-material/Email";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link } from "react-router-dom";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";


class QuotationView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statusAnchor: null,
      status: "Status",
	  emailDialogOpen: false,
emailAddress: ""
    };
  }

  handleEdit = () => {
    this.props.navigate("/Makequote?edit=" + this.props.id);
  };

  handleDuplicate = () => {
    this.props.navigate("/Makequote?duplicate=" + this.props.id);
  };
openEmailDialog = () => {
  this.setState({ emailDialogOpen: true, emailAddress: "" });
};

closeEmailDialog = () => {
  this.setState({ emailDialogOpen: false });
};

handleEmail = async () => {
 const emails = this.state.emailAddress ? this.state.emailAddress.trim() : "";
    const id = this.props.id;
	var type=1;
if (!emails) { alert("Please enter email address."); return; }
const emailList = emails.split(",").map((email) => email.trim()).filter((email) => email);
const invalidEmail = emailList.find((email) => !/^[^\s@]+@[^\s@]+.[^\s@]+$/.test(email));
if (invalidEmail) { alert("Invalid email address: " + invalidEmail); return; }
const formdata = new FormData();
formdata.append("action", "sendemail");
formdata.append("qu_id", id);
formdata.append("qu_type", 1);
formdata.append("emails", emailList.join(","));
try {
const response = await axios.post(Serverurl + "ajaxquotation.php", formdata);
console.log("EMAIL RESPONSE:", response.data);
if (response.data.status === "success") { alert("Quotation sent successfully."); this.closeEmailDialog(); } else { alert(response.data.message || "Email sending failed."); }
} catch (error) {
console.error("EMAIL ERROR:", error);
console.error("SERVER RESPONSE:", error.response?.data);
alert("Email sending failed.");
}
};

 handleShare = async () => {
	 
	  const id = this.props.id;
        const pdfUrl = Serverurl + "uploads/Quotation-" + id + ".pdf";

this.setState({ isSharing: true });

try {
    if (navigator.share) {
        await navigator.share({
            title: "Quotation #" + this.props.id,
          text: "Here is the Quotation PDF document.",
         url: pdfUrl
        });
    } else {
        await navigator.clipboard.writeText(pdfUrl);
        alert("PDF link copied to clipboard.");
    }
} catch (error) {
    if (error.name !== "AbortError") {
        console.error("Share error:", error);
        await navigator.clipboard.writeText(pdfUrl);
        alert("PDF link copied to clipboard.");
    }
} finally {
    this.setState({ isSharing: false });
}

    
  };
  
  
handleWhatsApp = async () => {
	let r = window.confirm("Please confirm to send on Whatsapp?");

    if (r === true) {
  const formData = new FormData();

  formData.append("action", "sendwhatsapp");
  formData.append("qu_id", this.props.id);
  formData.append("bu_id", localStorage.getItem("GBuserid"));
formData.append("bu_name", localStorage.getItem("GBname"));
formData.append("qu_type", 1);
  try {
    const response = await axios.post(
      Serverurl + "ajaxquotation.php",
      formData
    );

    console.log("WHATSAPP RESPONSE:", response.data);

    if (response.data.status === "success") {
      alert("Quotation sent successfully on WhatsApp.");
    } else {
      alert(
        response.data.message || "WhatsApp sending failed."
      );
    }

  }
	  catch (error) {
    console.error("WHATSAPP ERROR:", error);
    console.error("SERVER RESPONSE:", error.response?.data);

    alert("WhatsApp sending failed.");
  }
  }
};
  
  
  handleStatusClick = (event) => {
    this.setState({ statusAnchor: event.currentTarget });
  };

  handleStatusClose = () => {
    this.setState({ statusAnchor: null });
  };

  handleStatusChange = (status) => {
  const id = this.props.id;

  let r = window.confirm("Do you really want to update the status?");

  if (r === true) {

    this.setState({
      status: status,
      statusAnchor: null
    });

    const formData = new FormData();
    formData.append("qu_id[]", id);
    formData.append("qu_status", status);
    formData.append("action", "quotationstatus");

    axios
      .post(Serverurl + "ajaxquotation.php", formData)
      .then((res) => {
        if (String(res.data).trim() === "1") {
          alert("Status Updated");
        } else {
          alert("Status Update Failed");
        }
      })
      .catch(() => {
        alert("Status Update Failed");
      });

  } else {
    // Cancelled - don't change the status
    this.setState({
      statusAnchor: null
    });
  }
};

isStatusFinal = () => {
  return (
    this.state.status === "Approved" ||
    this.state.status === "Rejected"
  );
};
  render() {
    const id = this.props.id;

    const params = new URLSearchParams(window.location.search);
    const source = params.get("source");

    let pdfUrl;

    if (source === "quotation") {
        pdfUrl =
            Serverurl +
            "uploads/Quotation-" +
            id +
            ".pdf";
    } else {
        pdfUrl =
            Serverurl +
            "makequotationpdf.php?qu_id=" +
            id;
    }

    return (
        <>
	
        <ChevronLeftIcon
  className="global-back-arrow"
  onClick={() => window.history.back()}
/>

	
	<Dialog open={this.state.emailDialogOpen} onClose={this.closeEmailDialog} maxWidth="sm" fullWidth>
  <DialogTitle>Send Email</DialogTitle>
  <DialogContent>
    <TextField label="Email Address" type="email" value={this.state.emailAddress} onChange={(e) => this.setState({ emailAddress: e.target.value })} fullWidth margin="normal" />
    <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 2 }}>
      <Button variant="contained" sx={{ bgcolor: '#103f86 !important' }} onClick={this.closeEmailDialog}>Cancel</Button>
      <Button variant="contained" sx={{ bgcolor: '#103f86 !important' }} onClick={this.handleEmail}>Send</Button>
    </Box>
  </DialogContent>
</Dialog>

      <Box sx={{ height: "100vh", position: "relative" }}>
       

         <iframe
    title="Quotation PDF"
    src={pdfUrl}
    style={{
        width: "100%",
        height: "calc(100% - 120px)",
        border: "none"
    }}
/>

        {/* Bottom Action Bar */}
		<div className="sharingbuttons">
    <Box
  sx={{
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    background: "#f0f4f7",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
	flexWrap: "wrap",
    gap: 1,
    py: 1,
    px: 2,
    boxShadow: "0 -2px 8px rgba(0,0,0,0.15)",
    zIndex: 1000,
    overflowX: "auto",

    "@media (max-width:600px)": {
      px: 0.1, // reduce left/right padding on mobile
      gap: 0.5,
    },

    "& button": {
      flexShrink: 0,
    },
  }}
>

          <Button variant="contained" onClick={this.handleEdit}
		  sx={{ bgcolor: '#103f86' }}>
            <EditIcon />
          </Button>

          <Button
            variant="contained"
            
            onClick={this.handleDuplicate}
			 sx={{ bgcolor: '#103f86' }}
          >
            <ContentCopyIcon />
          </Button>

          <Button
            variant="contained"
           
            onClick={this.handleShare}
			sx={{ bgcolor: '#103f86 !important' }}
          >
            <ShareIcon />
				
          </Button>
		  	<Button
  variant="contained"
  onClick={this.handleWhatsApp}
  sx={{ bgcolor: '#103f86 !important' }}
>
  <WhatsAppIcon />
</Button>

<Button variant="contained"
            color="primary" onClick={this.openEmailDialog} 
			sx={{ bgcolor: '#103f86' }}>
  <EmailIcon />
</Button>
       <Button
  variant="contained"
  color={
    this.state.status === "Approved"
      ? "success"
      : this.state.status === "Rejected"
      ? "error"
      : "warning"
  }
  startIcon={<CheckCircleIcon />}
  onClick={this.handleStatusClick}
  disabled={this.isStatusFinal()}
  sx={{ bgcolor: '#103f86' }}
>
  {this.state.status}
</Button>



          <Menu
            anchorEl={this.state.statusAnchor}
            open={Boolean(this.state.statusAnchor)}
            onClose={this.handleStatusClose} 
          >
            <MenuItem onClick={() => this.handleStatusChange("Inprogress")}>
              Inprogress
            </MenuItem>
            <MenuItem onClick={() => this.handleStatusChange("Approved")}>
              Approved
            </MenuItem>
            <MenuItem onClick={() => this.handleStatusChange("Rejected")}>
              Rejected
            </MenuItem>
          </Menu>
        </Box>
		</div>
      </Box>
	  </>
    );
  }
}

function QuotationViewWrapper() {
  const { id } = useParams();
  const navigate = useNavigate();

  return <QuotationView id={id} navigate={navigate} />;
}

export default QuotationViewWrapper;